import React from 'react';
import { Link } from 'react-router-dom';

export function formatDay(value) {
  if (!value) return null;
  return new Date(value).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}

function formatDateTime(value) {
  if (!value) return null;
  const time = new Date(value).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  return `${formatDay(value)} ${time}`;
}

function formatExposure(seconds) {
  if (!seconds) return null;
  return seconds < 1 ? `1/${Math.round(1 / seconds)}s` : `${seconds}s`;
}

// No "Aperture:" or "ISO:" labels, and no "N/A" for a missing value: f/2.8, 1/250s
// and 24mm already say what they are, and dropping the labels is what lets a whole
// photo's details sit on one line instead of taking a panel away from the picture.
function exifFacts(exif) {
  if (!exif) return [];
  return [
    formatDateTime(exif.dateCaptured),
    [exif.cameraMake, exif.cameraModel].filter(Boolean).join(' '),
    exif.lens,
    exif.fStop && `f/${exif.fStop}`,
    formatExposure(exif.exposureTime),
    exif.iso && `ISO ${exif.iso}`,
    exif.focalLength && `${exif.focalLength}mm`
  ].filter(Boolean);
}

// The details strip under a photo, shared by the homepage and the lightbox.
function PhotoMeta({ place, placeTo, filename, position, exif, children }) {
  return (
    <div className="photo-meta">
      <div className="photo-meta-title">
        {place && (placeTo
          ? <Link to={placeTo} className="photo-meta-place">{place}</Link>
          : <span className="photo-meta-place">{place}</span>)}
        {filename && <span className="photo-meta-file">{filename}</span>}
        {position && <span className="photo-meta-file">{position}</span>}
      </div>
      <ul className="photo-meta-facts">
        {exifFacts(exif).map((fact) => <li key={fact}>{fact}</li>)}
      </ul>
      {children && <div className="photo-meta-actions">{children}</div>}
    </div>
  );
}

export default PhotoMeta;
